import { render, staticRenderFns } from "./ProviderModule.vue?vue&type=template&id=cfe5ea28&scoped=true"
import script from "./ProviderModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProviderModule.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProviderModule.vue?vue&type=style&index=0&id=cfe5ea28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe5ea28",
  null
  
)

export default component.exports